<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="detail">
              <HeaderBar title="详细消息"></HeaderBar>
              <div id="detail__card" class="detail__card">

              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
  import HeaderBar from '@/components/HeaderBar.vue';
  import { prefixedUrlAsset } from '@/utils/constants';
  export default {
    components: { HeaderBar },
    mounted() {
      this.getInfoData()
    },
    methods: {
      getInfoData() {
        this.axios.get(`${prefixedUrlAsset}/api/pubInfomation/viewPubInfo?infoId=${this.$route.query.id}`).then(res => {
          const div = document.getElementById('detail__card');
          if (res.data.code == '200') {
            div.innerHTML = res.data.data;
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .detail {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: white;
    padding: 10px 10px 0px 10px;
    margin-bottom: 20px;
    &__card {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      // align-items: flex-start;
      padding: 10px 10px 10px 10px;
      width: 100%;
      background-color: white;
      border-left: 1px solid #dcdcdc;
      border-right: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;
      border-radius: 0 0 15px 15px;
    }
  }
</style>
